import { render } from "./LegendTab.vue?vue&type=template&id=7bfb680c"
import script from "./LegendTab.vue?vue&type=script&lang=js"
export * from "./LegendTab.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList});
